import gql from "graphql-tag";

const tokenAuth = gql`
mutation TokenAuth($input: TokenAuthInput!) {
  tokenAuth(input: $input) {
    token
  }
}
`;

export default tokenAuth;